import React, { createContext, useContext, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { updateEntityChecksum } from "../utils/configChecksum/setterFunctions/entityConfig";
import { useAppBlocksContext } from "./AppBlocksContext";
import { useTreeContext } from "./TreeDataContext";
import { getTreeDataForEntity } from "../utils/treeData/treeDataUtils";
const EntityContextApi = createContext();

const useEntityContext = () => useContext(EntityContextApi);
const EntityContext = ({ children }) => {
  const [selectedEntity, setSelectedEntity] = useState({ id: "", name: "", parentData: "" });
  const [selectedEntitySm, setSelectedEntitySm] = useState({});
  const { getDetailviewConfig, layoutData, nestedGridData, layout } = useAppBlocksContext();

  const [entityUniqueField, setEntityUniqueField] = useState([]);
  // const [cartData, setCartData] = useState(getDefaultConfig("button"));
  const [smTriggerJobData, setSmTriggerJobData] = useState([]);

  const [allProCode, setAllProCode] = useState([]);

  // const [jobTriggerData, setJobTriggerData] = useState([]);
  // const [entityOwnerData, setEntityOwnerData] = useState({});
  const [entityInitData, setEntityInitData] = useState({
    jobs_trigger: [],
    activity_owner_assignment: {},
    state_change_logic: [],
    pre_activity_job: [],
    pre_submission: [],
    jobs_trigger_formula: "",
    activity_response: {},
    description: ""
  });

  const { setEntityExplorerData } = useTreeContext();

  const fetchAllEntities = async () => {
    const { data } = await axiosInstance.get(`/entity`);
    const treeData = getTreeDataForEntity(data);
    setEntityExplorerData(treeData);
    // if (!entityId && treeData.length > 0) {
    //   navigate(`./${treeData[0].id}`);
    // }
  };

  const payloadStateList = [
    entityUniqueField,
    entityInitData,
    smTriggerJobData,
    allProCode,
    // cartData,
    layout,
    layoutData.current,
    nestedGridData.current
  ];

  const getEntityConfig = () => {
    return {
      // entityConfig: { unique: entityUniqueField },
      entityConfig: { unique_fields: entityUniqueField },
      smConfig: entityInitData,
      cartConfig: {
        sm_trigger_job: smTriggerJobData,
        pro_code: allProCode,
        cart_detailview: {
          elements: getDetailviewConfig()?.elements || [],
          // cart_action: cartData
          cart_action: {}
        }
      }
    };
  };

  const handleSaveEntity = async () => {
    try {
      const config = getEntityConfig();
      await axiosInstance.put(`/state-machine/${selectedEntitySm.stateid}`, config.cartConfig);
      const { message } = await axiosInstance.put(`/entity/${selectedEntity.id}`, config.entityConfig);
      await axiosInstance.put(
        `/state-machine/${selectedEntitySm.stateid}/activities/${selectedEntitySm.id}`,
        config.smConfig
      );
      updateEntityChecksum(config.entityConfig, config.cartConfig, config.smConfig);
      return {
        data: {
          entity: config.entityConfig,
          sm: config.smConfig,
          cart: config.cartConfig
        },
        message
      };
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  };

  return (
    <EntityContextApi.Provider
      value={{
        selectedEntity,
        setSelectedEntity,
        selectedEntitySm,
        setSelectedEntitySm,
        entityUniqueField,
        setEntityUniqueField,
        fetchAllEntities,
        handleSaveEntity,
        getEntityConfig,
        entityInitData,
        setEntityInitData,
        // cartData,
        // setCartData,
        allProCode,
        setAllProCode,
        smTriggerJobData,
        setSmTriggerJobData,
        payloadStateList
      }}
    >
      {children}
    </EntityContextApi.Provider>
  );
};

export default EntityContext;
export { useEntityContext };
